import React from 'react';
import Box from "./Box";
import {useTheme} from "@mui/material/styles";
import Spinner from "./Spinner";
import {Logo} from "./Logo";
import {Property} from "csstype";

interface LoadingViewProps {

    text?: string,
    fixed?: boolean,
    dark?: boolean,
    style?: React.CSSProperties,
    position?: Property.Position,
    logoText?: string,
    expand?: boolean,

    [key: string]: any
}

function LoadingView({
                         text = "",
                         fixed,
                         dark,
                         style,
                         position = fixed ? "fixed" : "static",
                         logoText,
                         expand,
                         ...rest
                     }: LoadingViewProps) {
    style = {
        position,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
    };

    if (expand) {
        style = {
            width: "100%",
            height: "100%",
            ...style,
        }
    }

    if (fixed) {
        style = {
            width: "100%",
            height: "100%",
            ...style,
        }
    } else {
        style = {
            flex: 1,
            ...style,
        }
    }


    // The current theme's colours (was a fixed #622ff5: a purple flash before every theme, 10-02).
    const theme = useTheme();
    const bgcolor = theme.palette.background.default;
    const color = theme.palette.text.primary;

    return (
            <Box id={"loadingView"} style={style}
                 color={color}
                 bgcolor={bgcolor} column

                 {...rest}>
                {/*<MiniSpinner/>*/}
                <Box row center>
                    <Box style={{
                        marginRight: "15px",
                        marginLeft: "9px",
                        marginBottom: "10px"
                    }}>
                        <Logo color={color} text={logoText}/>
                    </Box>
                </Box>
                <Box row center marginTop={"10px"}>
                    <Box marginBottom={"7px"} marginRight={"8px"}>
                        {text}
                    </Box>
                    <Spinner mini/>
                </Box>
            </Box>
    );
}

export default LoadingView;
